import { Dialog } from 'apps/studio/components/dialogs'
import { CloseIcon } from '@gocanvas/gcds/icons'

// Returns a status text based on the percentage and messages
// last message always waits for 90% complete or above
const getStatusText = (percentage = 0, messages = []) => {
  if (!messages.length) return 'Processing'
  if (messages.length === 1) return messages[0]
  if (percentage >= 90) return messages[messages.length - 1]

  // Calculate which message to show based on percentage
  const messageCount = messages.length
  const availableRange = 90 // reserve 90% of the progress for messages before the last one
  const step = availableRange / (messageCount - 1)

  // Find which message segment we're in
  const messageIndex = Math.min(
    messageCount - 2, // Don't include the last message yet
    Math.floor(percentage / step)
  )

  return messages[messageIndex]
}

const ProgressBar = ({ percentage }) => {
  const width = `${percentage}%`
  return (
    <div className="gcds--progress-bar">
      <div
        className="progress-bar--value"
        style={{ width }}
        aria-valuenow={percentage}
        aria-valuemin="0"
        aria-valuemax="100"
      />
    </div>
  )
}

export const ProgressDialog = ({
  percentage = 0, // percentage should be between 0 and 100
  timeRemaining = 'Unknown',
  statusMessages,
  title = 'Processing',
  description = '',
  discreteText = '',
  onClose,
}) => {
  const statusText = getStatusText(percentage, statusMessages)

  return (
    <Dialog className="progress--dialog">
      <div className="dialog--header">
        <h2 className="dialog--title">{title}</h2>
        <div className="dialog--controls">
          {onClose && (
            <button
              className="gcds--button button--icon dialog--close-icon"
              type="button"
              onClick={onClose}
            >
              <CloseIcon />
            </button>
          )}
        </div>
      </div>
      <div className="dialog--content">
        <div className="progress--status">{statusText || description}</div>
        <ProgressBar percentage={percentage} />
        <div className="progress--details">
          <div>{timeRemaining}</div>
          {discreteText && <div>{discreteText}</div>}
          <div>{Math.round(percentage)}%</div>
        </div>
      </div>
    </Dialog>
  )
}
